itsoftApp.createModule("draggable", ['windowScroll'], function () {
    const module = this;

    class Draggable {
        constructor(container, state) {
            if (!container) {
                return;
            }

            this.names = {
                dragging: '_dragging',
            }

            this.slider = container;

            this.left = this.slider.querySelector('.js-draggable-left');
            this.right = this.slider.querySelector('.js-draggable-right');
            this.line = this.slider.querySelector('[data-type="resize"]');

            this.offsetTop = 150;

            this.state = {
                ...state,
                width: state.width || this.slider.clientWidth / this.defaultLineOffset,
            }

            this.activeFlag = false;
            this.dragging = false;

            this.medias = [
                window.matchMedia(`(max-width: 1023px)`),
                window.matchMedia(`(max-width: 767px)`),
                window.matchMedia(`(max-width: 480px)`),
            ]

            this.init();
        }

        init() {
            this.bindMethods();
            this.addEventListeners();

            this.render(this.state);

            this.onScroll();
        }

        bindMethods() {
            this.mouseDownHandler = this.mouseDownHandler.bind(this);
            this.mouseUpHandler = this.mouseUpHandler.bind(this);
            this.mouseUpDocHandler = this.mouseUpDocHandler.bind(this);
            this.moveHandler = this.moveHandler.bind(this);
            this.resizeHandler = this.resizeHandler.bind(this);
            this.onTouchStart = this.onTouchStart.bind(this);
            this.onTouchMove = this.onTouchMove.bind(this);
            this.onTouchEnd = this.onTouchEnd.bind(this);
            this.scrollHandler = this.scrollHandler.bind(this);
        }

        addEventListeners() {
            this.slider.addEventListener('mousedown', this.mouseDownHandler);
            this.slider.addEventListener('mouseup', this.mouseUpHandler);
            this.slider.addEventListener('touchstart', this.onTouchStart, { passive: false });
            this.slider.addEventListener('touchmove', this.onTouchMove, { passive: false });
            this.slider.addEventListener('touchend', this.onTouchEnd, { passive: false });

            document.addEventListener('mouseup', this.mouseUpDocHandler);
            document.addEventListener('mousemove', this.moveHandler);

            window.addEventListener('resize', this.resizeHandler);

            for (let index = 0; index < this.medias.length; index++) {
                const element = this.medias[index];
                element.addEventListener('change', this.resizeHandler);
            }

            itsoftApp.modules.windowScroll.addEvent(this.scrollHandler);
        }

        scrollHandler(e) {
            this.onScroll(e);
        }

        resizeHandler(e) {
            if (e.type === 'resize' && window.innerWidth > 1023) {
                this.onResize(e);
            } else if (e.type === 'change') {
                this.onResize(e);
            }
        }

        onResize(e) {
            this.setDefaultPos();
        }

        onScroll(e) {
            if (this.isBlockInWindow(this.slider) && !this.activeFlag) {
                this.activeFlag = true;
                this.slider.classList.add('_active');

                setTimeout(() => {
                    this.slider.classList.remove('_active');
                }, 3000 + 700);
            }
        }

        setDefaultPos() {
            this.state.width = this.slider.clientWidth / this.defaultLineOffset;
            this.render(this.state);
        }

        render(state) {
            this.left.style.clipPath = `inset(0px 0px 0px -${state.width}px)`;
            this.right.style.clipPath = `inset(0px 0px 0px ${state.width}px)`;
            this.line.style.marginLeft = state.width + 'px';
        }

        update(props) {
            this.state = {
                ...this.state,
                ...props,
            }
            this.render(this.state);
        }

        mouseDownHandler(e) {
            if (e.target.dataset.type === 'resize') {
                const event = e.touches ? e.touches[0] : e;
                this.dragging = true;
                this.currentClientX = event.clientX;
                this.slider.classList.add(this.names.dragging);
                if (this.activeFlag) {
                    this.slider.classList.remove('_active')
                    this.activeFlag = false;
                }
            }
        }

        mouseUpHandler(e) {
            e.stopPropagation();

            this.dragging = false;
            this.slider.classList.remove(this.names.dragging);
        }

        mouseUpDocHandler(e) {
            this.dragging = false;
            this.slider.classList.remove(this.names.dragging);
        }

        moveHandler(e) {
            if (!this.dragging) {
                return;
            }

            const event = e.touches ? e.touches[0] : e;

            if (e.touches) {
                e.preventDefault();
            }

            const newClientX = this.currentClientX - event.clientX;
            const curValue = this.state.width - newClientX;
            const stopSideOffset = 1;

            if (curValue < -stopSideOffset) {
                this.update({ width: -stopSideOffset });
                return;
            }

            if (curValue > this.slider.clientWidth + stopSideOffset) {
                this.update({ width: this.slider.clientWidth + stopSideOffset });
                return;
            }

            this.update({ width: curValue });
            this.currentClientX = event.clientX;
        }

        onTouchStart(e) {
            this.mouseDownHandler(e);
        };

        onTouchMove(e) {
            this.moveHandler(e);
        };

        onTouchEnd(e) {
            this.mouseUpHandler(e);
        };

        bodyLock(flag) {
            if (window.innerWidth < 1024) {
                if (flag) {
                    document.documentElement.classList.add('body-lock');
                } else {
                    document.documentElement.classList.remove('body-lock');
                }
            }
        }

        isBlockInWindow(el) {
            const { top, bottom } = el.getBoundingClientRect();
            const pointTop = top - this.offsetTop;
            const pointBottom = bottom - this.offsetTop;

            return pointTop < window.innerHeight && pointBottom < window.innerHeight;
        }

        get defaultLineOffset() {
            return window.innerWidth > 1023 ? 1.35 : 1.065;
        }
    }

    function initDraggable() {
        const selectors = document.querySelectorAll('.js-draggable');

        for (const el of selectors) {
            const instance = new Draggable(el, {});
            if (!el.instance) {
                el.instance = instance;
            }
        }
    }

    initDraggable();

    module.callback = Draggable;
});